import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {BloggerGroupsService} from "../services/blogger-groups.service";
import {BloggerGroupsData} from "../types/blogger-groups.types";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {BloggerGroupsStateService} from "../services/blogger-groups-state.service";
import {DeleteConfirmationParams} from "../../../../types/confirmation-modal.types";
import {defaultDeleteConfirmationParams} from "../../../../models/default-delete-confirmation-params";
import {ConfirmService} from "../../../../services/confirm.service";
import {currentBloggerGroupsModalName} from "../configs/current-blogger-groups-config";
import {RecordUpdateRequestParams} from "../../../../types/records-table.types";
import {bloggerGroupsResourceType} from "../configs/blogger-groups-config";
import {LoaderComponent} from "../../../../../shared/components/loader/loader.component";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-current-blogger-groups-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatIcon,
    MatIconButton,
    MatTooltip,
    LoaderComponent,
    MatFormField,
    MatLabel,
    FormsModule,
    MatInput
  ],
  templateUrl: './current-blogger-groups-modal.component.html',
  styleUrl: './current-blogger-groups-modal.component.scss'
})
export class CurrentBloggerGroupsModalComponent extends BaseModalComponent {
  public bloggerGroupsStateService: BloggerGroupsStateService = inject(BloggerGroupsStateService);
  private bloggerGroupsService: BloggerGroupsService = inject(BloggerGroupsService);
  private confirmService: ConfirmService = inject(ConfirmService);

  public override async ngOnInit() {
    super.ngOnInit();
    this.modalStatesService.openModal(currentBloggerGroupsModalName);
    this.loadingService.setIsLoadingState(true);
    await this.bloggerGroupsService.getBloggerGroupsData();
    this.loadingService.setIsLoadingState(false);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(currentBloggerGroupsModalName);
  }

  public async handleUpdateName(bloggerGroup: BloggerGroupsData): Promise<void> {
    const recordUpdateRequestParams: RecordUpdateRequestParams = {
      path: bloggerGroupsResourceType.path,
      recordId: bloggerGroup.id,
      fieldName: 'name',
      value: bloggerGroup.name
    };

    await this.updatedRecordField<BloggerGroupsData>(recordUpdateRequestParams)
      .then(updatedRecord => this.bloggerGroupsStateService.updateBloggerGroups(updatedRecord));
  }

  public async handleClickDelete(id: number): Promise<void> {
    const deleteConfirmationParams: DeleteConfirmationParams = {
      ...defaultDeleteConfirmationParams,
      description: `Вы уверены, что хотите удалить группу №${id}?`
    }

    const isConfirmed = await this.confirmService.getDeleteConfirmation(deleteConfirmationParams);
    if (!isConfirmed) { return; }

    await this.bloggerGroupsService.deleteBloggerGroup(id)
      .then(() => {
        this.snackbarService.showMessage({message: 'Группа удалена'});
        this.closeDialog('success');
      })
      .catch(() => this.closeDialog('cancel'))
  }
}
